import { membershipProductEvaluationHandler } from './membershipProductEvaluation';
import { evaluateMembershipProductActions } from './oneFrontActions';
export const flightsPaymentPrimeProviderProps = {
  listenEvaluationChanges: membershipProductEvaluationHandler.onEvaluation,
  stopListenEvaluationChanges: membershipProductEvaluationHandler.stopOnEvaluation
};
export const evaluateMembershipProduct = evaluateMembershipProductActions;